import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { useMediaQuery } from 'hooks/use-media-query';

import { RewardPointCost } from '../reward-point-cost';

import {
  PointsContainer,
  PointsText,
  RewardLabel,
  StyledPointsIcon,
  StyledRewardLockIcon,
} from './incentive-details.styled';
import { IRewardPoints } from './types';

export const RewardPoints: FC<IRewardPoints> = ({ pointCost, locked }) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery('mobile');
  return (
    <PointsContainer>
      {isMobile && !locked && <RewardLabel>{formatMessage({ id: 'reward' })}</RewardLabel>}
      <PointsText>
        {locked ? <StyledRewardLockIcon /> : <StyledPointsIcon />}
        <RewardPointCost pointCost={pointCost}>
          <strong>{formatMessage({ id: 'pointsNumber' }, { points: pointCost })}</strong>
        </RewardPointCost>
      </PointsText>
    </PointsContainer>
  );
};
